import React, { useState, useEffect, useRef } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import "../index.css";
import { json } from "../json";
import { useSearchParams } from 'react-router-dom';
import { themeJson } from "../theme";
import ReCAPTCHA from "react-google-recaptcha";

function SurveyComponent() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('sessionId');
    const [recaptchaValue, setRecaptchaValue] = useState(null);

    // Initialize the survey model with useRef to keep it Persistent
    const surveyRef = useRef(null);

    if (!surveyRef.current) {
        surveyRef.current = new Model(json);
        surveyRef.current.applyTheme(themeJson);

 // Dynamically set max value for IncidentDateTime and DOB fields after each question render
 surveyRef.current.onAfterRenderQuestion.add((sender, options) => {
    if (options.question.name === 'IncidentDateTime') {
        // Wait until the input element is rendered for IncidentDateTime
        const inputElement = options.htmlElement.querySelector('input[type="datetime-local"]');
        if (inputElement) {
            const currentDateTime = new Date().toISOString().slice(0, 16); // Current date and time in YYYY-MM-DDTHH:mm
            inputElement.max = currentDateTime; // Set the max attribute dynamically for datetime-local
        }
    }
    if (options.question.name === 'DOB') {
        // Wait until the input element is rendered for DOB
        const inputElement = options.htmlElement.querySelector('input[type="date"]');
        if (inputElement) {
            const currentDate = new Date().toISOString().slice(0, 10); // Current date in YYYY-MM-DD
            inputElement.max = currentDate; // Set the max attribute dynamically for date
        }
    }
});


        surveyRef.current.onComplete.add((sender) => {
            console.log("Survey Data:", JSON.stringify(sender.data, null, 3));
            console.log("Session ID:", sessionId);

            fetch('https://lgapp-drby-uks-p-capture-01.azurewebsites.net:443/api/Capture-UserSubmission/triggers/When_a_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=UQ1HetSL8n70tnATPA8OlKvdBE8uCNcu0ysBvF94eFA', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...sender.data, 
                    recaptchaValue: recaptchaValue 
                }, null, 3),
            })
            .finally(() => {
                window.location.href = 'https://snap.derbyshire.police.uk/thankyou.html'; // Replace with your actual url
            });
        });
    }

    // Handle ReCAPTCHA changes
    const onRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };

    useEffect(() => {
        const completeButton = document.querySelector('.sd-btn.sd-btn--action.sd-navigation__complete-btn');
        const recaptchaContainer = document.querySelector('.recaptcha-container');
        const surveyElement = document.querySelector('.sd-page.sd-body__page.sd-page__empty-header');
    
        const positionRecaptcha = () => {
            if (completeButton && recaptchaContainer) {
                const buttonRect = completeButton.getBoundingClientRect();
                recaptchaContainer.style.position = 'absolute';
                recaptchaContainer.style.top = `${buttonRect.top + window.scrollY + 29}px`; // Adjust this value as needed
                recaptchaContainer.style.left = `${buttonRect.right + 170}px`;
            }
        };
    
        positionRecaptcha(); // Initial positioning
    
        // Reposition on window resize
        window.addEventListener('resize', positionRecaptcha);
    
        // Observe changes in the panel with the specified classes
        const observer = new MutationObserver(positionRecaptcha);
        if (surveyElement) {
            observer.observe(surveyElement, { 
                childList: true, 
                subtree: true 
            });
        }
    
        // Use ResizeObserver to detect changes in size
        const resizeObserver = new ResizeObserver(() => {
            positionRecaptcha();
        });
    
        if (surveyElement) {
            resizeObserver.observe(surveyElement);
        }
    
        return () => {
            window.removeEventListener('resize', positionRecaptcha); // Cleanup event listener on unmount
            observer.disconnect(); // Disconnect the observer on unmount
            resizeObserver.disconnect(); // Disconnect the resize observer on unmount
        };
    }, [recaptchaValue]);

    useEffect(() => {
        const completeButton = document.querySelector('.sd-btn.sd-btn--action.sd-navigation__complete-btn');

        if (completeButton) {
            completeButton.disabled = !recaptchaValue; // Disable the button if recaptchaValue is null or undefined
        }
    }, [recaptchaValue]); // This effect runs when recaptchaValue changes
    
    return (
        <div>
        
            <Survey model={surveyRef.current} />
            <div className="recaptcha-container">
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={onRecaptchaChange}
                />
            </div>
        </div>
    );
}

export default SurveyComponent;
